<template>
  <div id="loading-bg">
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userRolesDic: {
        'admin': 'admin',
        'head-of-fleet': 'team-leader',
        'finance': 'accounting',
        'manager': 'warehouse-agent',
        'customer-support': 'customer-support',
        'transporter': 'traveller',
        'merchant': 'merchant',
        'growth-hacker': 'growth-hacker',
        'fc-operations-supervisor': 'fc-operations-supervisor',
        'fc-receiving-agent': 'fc-receiving-agent',
        'fc-inbounding-agent':'fc-inbounding-agent',
        'fc-storing-agent': 'fc-storing-agent',
        'fc-packing-agent': 'fc-packing-agent',
        'fc-picking-agent': 'fc-picking-agent',
        'sales': 'sales',
        'ops-admin': 'ops-admin',
        'commercial-admin': 'commercial-admin'
      }
    }
  },
  methods: {
    handleLoginEvent (data) {
      this.$acl.change('guest')
      const profile = data.profile || {}
      const roles = profile[`${process.env.VUE_APP_API_URL}/role`] || []
      const appMetadata = profile[`${process.env.VUE_APP_API_URL}/app_metadata`] || {}
      const profileSub = profile.sub || ''
      if (roles[0] === 'merchant' && !appMetadata.terms_conditions) {
        this.$router.push('/ar/pages/terms-and-conditions').catch(() => {})
      } else {
        this.$store.dispatch('updateUserInfo', {
          displayName: profile.name,
          email: profile.email,
          photoURL: profile.picture,
          providerId: profileSub.substr(0, profileSub.indexOf('|')),
          uid: profileSub,
          userRole: roles[0]
        }).then(() => {
          this.$acl.change(this.$store.state.AppActiveUser.userRole)
          if (this.$store.state.AppActiveUser.userRole === 'customer-agent' || this.$store.state.AppActiveUser.userRole === 'merchant-agent') {
            this.$router.push(`/${this.$cookies.get('language')}/${this.$store.state.AppActiveUser.userRole}/task-list`).catch(() => {})
          } else {
            this.$router.push(data.state.target || `/${this.$cookies.get('language')}/${this.userRolesDic[this.$store.state.AppActiveUser.userRole]}/dashboard`).catch(() => {})
          }
        })
      }
    }
  },
  async created () {
    if (!this.$cookies.get('language')) {
      this.$cookies.set('language', 'ar', '100y')
    }
    try {
      await this.$auth.handleAuthentication()
    } catch (error) {
      this.authError = error
      this.$router.push('/pages/login').catch(() => {})
    }
  }
}

</script>

<style lang="scss">
@import "../assets/css/loader.css";
</style>